<template>
  <div class="socContent">
    <verified-soc v-if="verifiedSoc" :soc="data" @remove="selfDestruct"></verified-soc>
    <not-verified-soc v-else :suborder="data.suborder"></not-verified-soc>
  </div>
</template>

<script>
import NotVerifiedSoc from './NotVerifiedSoc.vue';
import VerifiedSoc from './VerifiedSoc.vue';

export default {
  name: 'SocItem',
  components: {
    VerifiedSoc,
    NotVerifiedSoc,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    verifiedSoc() {
      return this.data.verified;
    },
  },
  methods: {
    selfDestruct(soc) {
      this.$emit('remove', soc);
    },
  },
  filters: {
    tostring(val) {
      val.toString();
    },
  },
};
</script>

<style scoped>
  .socContent {
    display: inline-block;
    width: calc(100% - 20px);
  }
  .fa-stack {
    font-size: 0.6em;
    margin-top: -3px;
    padding-bottom: 2px;
  }
  i { vertical-align: middle; }
  .req-at{
    float: right;
    margin: 0 4px 0 6px;
  }
  .non-clickeable {
    font-size: 7px;
    padding-top: 3px;
    margin-right: 3px;
    float: right;
    color: darkgray;
  }
  .clickeable {
    font-size: 7px;
    padding-top: 3px;
    margin-right: 3px;
    float: right;
    color: darkgray;
    cursor: pointer;
    animation: jumps .5s infinite;
  }
  .clickeable:hover {
    color: #AAD500;
    animation: none;
  }
  @keyframes jumps {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(4px);
    }
    100% {
      transform: translateY(0px);
    }
  }
  .point-package {
    color: darkgray;
  }
  .point-map {
    color: #E6A23C;
    font-size: 8px;
    top: -0.5px;
  }
  .locality-tag{
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-left: 10px;
    max-width: calc(100% - 14ch - 110px);
  }
</style>
